import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v1 as uuidv1 } from 'uuid';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import QuestionContainer from './QuestionContainer';
import {
  translateQuestionTypes, getQuestion, QuestionShape, defaultQuestion,
} from './questionTypesConsts';
import useStyles from './styles';
import Star from '../../common/icons/Star';


const RatingQuestion = ({
  question: propQuestion, onConfirm, onHide, onGoBack, editMode,
}) => {
  const { t } = useTranslation(['translation']);
  const question = getQuestion(propQuestion);
  const [questionName, setQuestionName] = useState(question.name);
  const [error, setError] = useState(null);
  // const [lowGradeName, onChangeLowGradeName] = useInputState(question.lowGradeName);
  // const [highGradeName, onChangeHighGradeName] = useInputState(question.highGradeName);

  const { RATING_QUESTION } = translateQuestionTypes(t);

  const saveQuestion = () => {
    if (questionName === '') {
      setError(t('CAMPAIGN.QUESTIONNAIRE.EMPTY_QUESTION_ERROR'));
      return;
    }
    onConfirm({
      id: uuidv1(),
      name: questionName,
      // lowGradeName,
      // highGradeName,
      type: RATING_QUESTION,
    });
  };

  const onChangeQuestionName = ev => {
    setError(null);
    setQuestionName(ev.target.value);
  };

  const classes = useStyles();
  const nameStyle = classnames(classes.input, classes.questionInput);
  // const gradeStyle = classnames(classes.input, classes.gradeInput);

  // Star colors
  const YELLOW = '#FFD700';
  const GREY = '#A9A9A9';
  const starFills = [YELLOW, YELLOW, YELLOW, GREY, GREY];

  return (
    <QuestionContainer
      title={RATING_QUESTION}
      onGoBack={onGoBack}
      saveQuestion={saveQuestion}
      onHide={onHide}
    >
      <React.Fragment>
        <div className={classes.questionContainer}>
          <input
            className={nameStyle}
            value={questionName}
            onChange={onChangeQuestionName}
            placeholder={t('CAMPAIGN.QUESTIONNAIRE.QUESTION_PLACEHOLDER')}
            disabled={editMode}
          />
        </div>
        <div>
          <h4 className={classes.optionsHeader}>{t('CAMPAIGN.QUESTIONNAIRE.QUESTION_OPTIONS_RATING_QUESTION')}</h4>
          <div className={classes.gradeZone}>
            {/* <input
              className={gradeStyle}
              value={lowGradeName}
              onChange={onChangeLowGradeName}
              placeholder="Título (1)"
              disabled={editMode}
            /> */}
            <div className={classes.stars}>
              {starFills.map((fill, index) => (
                <Star key={index} width={25} height={25}  fill={fill} />
              ))}
            </div>
            {/* <input
              className={gradeStyle}
              value={highGradeName}
              onChange={onChangeHighGradeName}
              placeholder="Título (5)"
              disabled={editMode}
            /> */}
          </div>
        </div>
        { error && <Alert color="danger">{error}</Alert> }
      </React.Fragment>
    </QuestionContainer>
  );
};


RatingQuestion.defaultProps = {
  question: defaultQuestion,
};

RatingQuestion.propTypes = {
  question: QuestionShape,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
};

export default RatingQuestion;
